module.exports = __webpack_public_path__ + "img/consult_info4.0ca2425f.png";